import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import {getMonthFromString} from "./dateUtils";

function fitToColumn(arrayOfArray) {
    // get maximum character of each column
    return arrayOfArray.map((a, i) => ({ wch: a.toString().length }));
}

function set_right_to_left(wb/*:Workbook*/) {
    if(!wb.Workbook) wb.Workbook = {};
    if(!wb.Workbook.Views) wb.Workbook.Views = [];
    if(!wb.Workbook.Views[0]) wb.Workbook.Views[0] = {};
    wb.Workbook.Views[0].RTL = true;
}

export const generateCommonPayrollFile = (date, data) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll");

    /* fix headers */
    XLSX.utils.sheet_add_aoa(worksheet, [["מספר עובד", "שם מלא", "מקדמה"]], { origin: "A1" });

    /* calculate column width */
    const max_width = data.reduce((w, r) => Math.max(w, r.name.length), 10);
    worksheet["!cols"] = [ { wch: max_width }, { wch: max_width }, { wch: max_width }, { wch: max_width } ];

    /* create an XLSX file and try to save to Presidents.xlsx */
    XLSX.writeFile(workbook, "Payroll" + date + ".xlsx");
}

export const generateShiklulitPayrollFile = (date, data) => {

    let jsonData;

    try {
        const workbook = XLSX.read(data, {type: "base64"});
        const sheet_name_list = workbook.SheetNames;
        jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet_name_list[0]]);
    } catch (e) {

    }

    const monthRow = getMonthFromString(date)

    let finalArray = []
    jsonData.forEach((item) => {
        finalArray.push({
            "hodesh": monthRow,
            "misparOved": item["מספר עובד"],
            "sugReshuma": "3",
            "kodRehiv": "1",
            "taarif": item["מקדמה"],
            "kamut": "1",
            "": item["שם עובד"]
        })
    })

    const worksheet = XLSX.utils.json_to_sheet(finalArray);
    const workbook = XLSX.utils.book_new();
    set_right_to_left(workbook)
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    /* fix headers */
    XLSX.utils.sheet_add_aoa(worksheet, [["חודש", "מספר עובד", "סוג רשומה", "קוד רכיב", "תעריף", "כמות"]], { origin: "A1" });

    /* calculate column width */
    //const max_width = finalArray.reduce((w, r) => Math.max(w, r.length), 10);
    //worksheet["!cols"] = [ { wch: max_width }, { wch: max_width }, { wch: max_width }, { wch: max_width } ];

    /* create an XLSX file and try to save to Presidents.xlsx */
    XLSX.writeFile(workbook, "Payroll-Shiklulit-" + date + ".xlsx");
}

export const exportErrorsFile = (errorsList) => {
    try {
        let finalErrorsArray = []
        errorsList.forEach((item) => {
            let employeeName = "";
            let govId = "";
            let employeeId = "";
            let metadata = JSON.parse(item['metadata']);
            if(metadata) {
                if(metadata['fullName']) {
                    employeeName = metadata['fullName']
                }
                else {
                    if(metadata['firstName']) {
                        employeeName = metadata['firstName'];
                    }
                    if(metadata['lastName']) {
                        employeeName = employeeName + ' ' + metadata['lastName'];
                    }
                }

                if(metadata['govId']) {
                    govId = metadata['govId']
                }
                if(metadata['employeeId']) {
                    employeeId = metadata['employeeId']
                }
            }
            finalErrorsArray.push({
                "message": item["message"],
                "state": item["state"],
                "companyName": item["companyName"],
                "integrationProviderName": item['integrationProviderName'],
                "count": item['count'],
                "employeeName": employeeName,
                "govId": govId,
                "employeeId": employeeId,
                "metadata": item['metadata']
            })
        })
        const worksheet = XLSX.utils.json_to_sheet(finalErrorsArray);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ErrorsList");

        /* fix headers */
        XLSX.utils.sheet_add_aoa(worksheet, [["Message", "State", "Company", "Integration Provider", "Error Count", "Employee Name", "Employee Gov Id", "Employee Id", "Error Metadata"]], { origin: "A1" });

        worksheet['!cols'] = fitToColumn(finalErrorsArray);

        XLSX.writeFile(workbook, "errors.xlsx");
    } catch (e) {
    }
}

export const exportRawXlsxFile = (data) => {
    try {
        const workbook = XLSX.read(data, {type: "base64"});
        XLSX.writeFile(workbook, "Payro-Report.xlsx");
    } catch (e) {
    }
}

export const exportArrayToXlsxFile = (items) => {
    const worksheet = XLSX.utils.json_to_sheet(items);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "transfers");
    XLSX.writeFile(workbook, "transfers.xlsx");
}

export const exportMalamPayrollFile = (date, data) => {
    try {
        const workbook = XLSX.read(data, {type: "base64"});
        const sheet_name_list = workbook.SheetNames;
        let jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet_name_list[0]]);
        let finalArray = []
        jsonData.forEach((item) => {
            finalArray.push({
                "תעודת זהות": item["תעודת זהות"],
                "שם עובד": item["שם עובד"],
                "מקדמה": item["מקדמה"],
            })
        })

        const newWorksheet = XLSX.utils.json_to_sheet(finalArray);
        const newWorkbook = XLSX.utils.book_new();
        set_right_to_left(newWorkbook)
        XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, "Sheet1");

        /* fix headers */
        XLSX.utils.sheet_add_aoa(newWorksheet, [["תעודת זהות","שם עובד", "מקדמה" ]], { origin: "A1" });

        XLSX.writeFile(workbook, "Payroll-Malam-" + date + ".xlsx");
    } catch (e) {
    }
}

export const exportHilanPayrollFile = (date, data) => {
    try {
        const workbook = XLSX.read(data, {type: "base64"});
        const sheet_name_list = workbook.SheetNames;
        let jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet_name_list[0]]);
        let finalArray = []
        jsonData.forEach((item) => {
            finalArray.push({
                "תעודת זהות": item["תעודת זהות"],
                "שם עובד": item["שם עובד"],
                "מקדמה": item["מקדמה"],
            })
        })

        const newWorksheet = XLSX.utils.json_to_sheet(finalArray);
        const newWorkbook = XLSX.utils.book_new();
        set_right_to_left(newWorkbook)
        XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, "Sheet1");

        /* fix headers */
        XLSX.utils.sheet_add_aoa(newWorksheet, [["תעודת זהות","שם עובד", "מקדמה" ]], { origin: "A1" });

        XLSX.writeFile(workbook, "Payroll-Hilan" + date + ".xlsx");
    } catch (e) {
    }
}

function groupByCompanyId(data) {
    return Object.values(data.reduce((result, currentItem) => {
        // If the company id is not in the result object, add an empty array
        if (!result[currentItem.companyId]) {
            result[currentItem.companyId] = [];
        }

        // Push the current item into the appropriate array in the result object
        result[currentItem.companyId].push(currentItem);

        // Return the result object for the next iteration
        return result;
    }, {}));
}

const getDailyTransferIdForCompanyId = (companyId) => {
    // Special cases
    if (companyId === 1) return '1000';
    if (companyId === 12) return '';

    // Handle irregular cases (4, 6, 7, 8-11)
    const irregularMappings = {
        4: '4002',
        6: '4000',
        7: '4001',
        8: '4003',
        9: '4004',
        10: '4005',
        11: '4006'
    };

    if (irregularMappings[companyId]) {
        return irregularMappings[companyId];
    }

    // For company IDs 13 and above, use the pattern: companyId + 3994
    if (companyId >= 13) {
        return String(companyId + 3994);
    }

    // Fallback for any other cases
    return '';
};

export const generateDailyTransfers = (data) => {

    let zip = new JSZip();

    let companyIds = groupByCompanyId(data);

    companyIds.forEach((transfers) => {
        let finalArray = []
        transfers.forEach((item) => {
            finalArray.push({
                "fullName": item["fullName"],
                "identifier": item["govId"] || "",
                "accountId": item["accountId"],
                "bankId": item["bankId"],
                "branchId": item["branchId"],
                "amount": item["amount"],
                "comment": item["transferId"]
            })
        })
        const worksheet = XLSX.utils.json_to_sheet(finalArray);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "DailyTransfers");

        /* fix headers */
        XLSX.utils.sheet_add_aoa(worksheet, [["שם המוטב", "מזהה מוטב", "מספר החשבון", "בנק", "סניף", "סכום", "הערה"]], { origin: "A1" });

        //XLSX.writeFile(workbook, "DailyTransfers-" + transfers[0]['companyId'] + ".xlsx");
        const companyId = Number(transfers[0]['companyId']);
        const filename = "DailyTransfers-" + getDailyTransferIdForCompanyId(companyId)  + ".xlsx";
        const wbout = XLSX.write(workbook, {bookType:'xlsx', type:'binary'});

        zip.file(filename, wbout, {binary:true});
    })

    zip.generateAsync({type:"blob"}).then(function(content) {
        saveAs(content, "DailyTransfers.zip");
    });
}

export const downloadUserRegistrations = (data) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Fix headers with Hebrew text
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "UserRegistrations");

    // Write the workbook to a file and save it
    XLSX.writeFile(workbook, "UserRegistrations.xlsx");
}

export const exportTransfersSummary = (data, startDate, endDate) => {
    const workbook = XLSX.utils.book_new();
    set_right_to_left(workbook);
    const rows = data.map(r => ({
        'חברה': r.company_name,
        'משתמשים ייחודיים': Number(r.unique_users),
        'סה"כ בקשות': Number(r.total_applications),
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    ws['!cols'] = [{ wch: 30 }, { wch: 20 }, { wch: 15 }];
    XLSX.utils.book_append_sheet(workbook, ws, 'סיכום העברות');
    XLSX.writeFile(workbook, `transfers-summary-${startDate}-to-${endDate}.xlsx`);
};

export const downloadNewUsers = (data) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with Hebrew headers
    const exportData = data.map(user => ({
        'שם החברה': user.companyName || '',
        'שם מלא': user.fullName || '',
        'תאריך רישום': user.createdDate ? new Date(user.createdDate).toLocaleDateString('he-IL') : '',
        'מספר טלפון': user.phoneNumber || ''
    }));

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Set RTL for Hebrew
    set_right_to_left(workbook);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "NewUsers");

    // Write the workbook to a file and save it
    XLSX.writeFile(workbook, "NewUsers.xlsx");
}

export const downloadEndOfMonthSummary = (data, month) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with Hebrew headers
    const exportData = data.map(company => {
        const subscriptionAmountNoVAT = company.subscriptionAmount || 0;
        const subscriptionAmountWithVAT = subscriptionAmountNoVAT * 1.18;

        return {
            'שם לקוח': company.name || '',
            'שם משפטי': company.legalName || '',
            'דרישת תשלום מקדמות': company.totalApplicationsCount || 0,
            'חשבונית דמי מנוי - לא כולל מע״מ': subscriptionAmountNoVAT,
            'חשבונית דמי מנוי - כולל מע״מ': subscriptionAmountWithVAT,
            'עמלות העברה - הסכום כולל מע״מ': company.transferFees || 0
        };
    });

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Set RTL for Hebrew
    set_right_to_left(workbook);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "סיכום חודשי");

    // Set column widths for better readability
    worksheet["!cols"] = [
        { wch: 25 }, // שם לקוח
        { wch: 25 }, // שם משפטי
        { wch: 22 }, // דרישת תשלום מקדמות
        { wch: 28 }, // חשבונית דמי מנוי - לא כולל מע״מ
        { wch: 28 }, // חשבונית דמי מנוי - כולל מע״מ
        { wch: 30 }  // עמלות העברה - הסכום כולל מע״מ
    ];

    // Generate filename with month
    const fileName = month
        ? `דוח-סיכום-חודשי-${month.replace('/', '-')}.xlsx`
        : 'דוח-סיכום-חודשי.xlsx';

    // Write the workbook to a file and save it
    XLSX.writeFile(workbook, fileName);
}

export const generateDailyTransfersNew = (data) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare a single array for all transfers
    let finalArray = [];

    // Process all data into a single array
    data.forEach((item) => {
        finalArray.push({
            "fullName": item["fullName"],
            "identifier": item["govId"] || "",
            "accountId": item["accountId"],
            "bankId": item["bankId"],
            "branchId": item["branchId"],
            "amount": item["amount"],
            "comment": item["transferId"]
        });
    });

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(finalArray);

    // Fix headers with Hebrew text
    XLSX.utils.sheet_add_aoa(worksheet, [["שם המוטב", "מזהה מוטב", "מספר החשבון", "בנק", "סניף", "סכום", "הערה"]], { origin: "A1" });

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "DailyTransfers");

    // Write the workbook to a file and save it
    XLSX.writeFile(workbook, "DailyTransfers.xlsx");
}

export const generatePayroDeductionsReport = (transfersData, payPeriod, companyId = null) => {
    try {
        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Set RTL for Hebrew
        set_right_to_left(workbook);

        // Transform the data to the required format
        const finalArray = transfersData.map((item) => ({
            "שם עובד": item.employeeName,
            "תעודת זהות": item.govId,
            "מקדמה": item.totalTransferFee + item.totalAmount
        }));

        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(finalArray);

        // Fix headers with Hebrew text
        XLSX.utils.sheet_add_aoa(worksheet, [["שם עובד", "תעודת זהות", "מקדמה"]], { origin: "A1" });

        // Calculate column width
        const max_width = finalArray.reduce((w, r) => Math.max(w, r["שם עובד"].length), 15);
        worksheet["!cols"] = [
            { wch: max_width }, // שם עובד
            { wch: 15 }, // תעודת זהות
            { wch: 12 }  // מקדמה
        ];

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll");

        // Write the workbook to a file and save it
        const companyPart = companyId ? `-Company-${companyId}` : "";
        XLSX.writeFile(workbook, `Payro-Report${companyPart}-${payPeriod}.xlsx`);
    } catch (e) {
        console.error("Error generating Payro deductions report:", e);
    }
}

export const generatePayroDeductionsReportWithPhone = (transfersData, payPeriod, companyId = null) => {
    try {
        const workbook = XLSX.utils.book_new();
        set_right_to_left(workbook);

        const finalArray = transfersData.map((item) => ({
            "שם עובד": item.employeeName,
            "תעודת זהות": item.govId,
            "מספר טלפון": item.phoneNumber || '',
            "מקדמה": item.totalTransferFee + item.totalAmount
        }));

        const worksheet = XLSX.utils.json_to_sheet(finalArray);
        XLSX.utils.sheet_add_aoa(worksheet, [["שם עובד", "תעודת זהות", "מספר טלפון", "מקדמה"]], { origin: "A1" });

        const max_width = finalArray.reduce((w, r) => Math.max(w, r["שם עובד"].length), 15);
        worksheet["!cols"] = [
            { wch: max_width },
            { wch: 15 },
            { wch: 15 },
            { wch: 12 }
        ];

        XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll");

        const companyPart = companyId ? `-Company-${companyId}` : "";
        XLSX.writeFile(workbook, `Payro-Report-With-Phone${companyPart}-${payPeriod}.xlsx`);
    } catch (e) {
        console.error("Error generating Payro deductions report with phone:", e);
    }
}

// New version that works with transfersFeesReport JSON data
export const generateShiklulitPayrollFileFromTransfers = (payPeriod, transfersData) => {
    try {
        const monthRow = getMonthFromString(payPeriod);

        let finalArray = [];
        transfersData.forEach((item) => {
            finalArray.push({
                "hodesh": monthRow,
                "misparOved": item.employeeInternalId || "", // Use internal ID if available
                "sugReshuma": "3",
                "kodRehiv": "1",
                "taarif": item.totalTransferFee + item.totalAmount,
                "kamut": "1",
                "": item.employeeName
            });
        });

        const worksheet = XLSX.utils.json_to_sheet(finalArray);
        const workbook = XLSX.utils.book_new();
        set_right_to_left(workbook);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Fix headers
        XLSX.utils.sheet_add_aoa(worksheet, [["חודש", "מספר עובד", "סוג רשומה", "קוד רכיב", "תעריף", "כמות"]], { origin: "A1" });

        // Create an XLSX file and save it
        XLSX.writeFile(workbook, "Payroll-Shiklulit-" + payPeriod + ".xlsx");
    } catch (e) {
        console.error("Error generating Shiklulit payroll file:", e);
    }
}

// New version that works with transfersFeesReport JSON data
export const exportMalamPayrollFileFromTransfers = (payPeriod, transfersData) => {
    try {
        let finalArray = [];
        transfersData.forEach((item) => {
            finalArray.push({
                "תעודת זהות": item.govId,
                "שם עובד": item.employeeName,
                "מקדמה": item.totalTransferFee + item.totalAmount,
            });
        });

        const newWorksheet = XLSX.utils.json_to_sheet(finalArray);
        const newWorkbook = XLSX.utils.book_new();
        set_right_to_left(newWorkbook);
        XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, "Sheet1");

        // Fix headers
        XLSX.utils.sheet_add_aoa(newWorksheet, [["תעודת זהות","שם עובד", "מקדמה"]], { origin: "A1" });

        XLSX.writeFile(newWorkbook, "Payroll-Malam-" + payPeriod + ".xlsx");
    } catch (e) {
        console.error("Error generating Malam payroll file:", e);
    }
}

// New version that works with transfersFeesReport JSON data
export const exportHilanPayrollFileFromTransfers = (payPeriod, transfersData) => {
    try {
        let finalArray = [];
        transfersData.forEach((item) => {
            finalArray.push({
                "תעודת זהות": item.govId,
                "שם עובד": item.employeeName,
                "מקדמה": item.totalTransferFee + item.totalAmount,
            });
        });

        const newWorksheet = XLSX.utils.json_to_sheet(finalArray);
        const newWorkbook = XLSX.utils.book_new();
        set_right_to_left(newWorkbook);
        XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, "Sheet1");

        // Fix headers
        XLSX.utils.sheet_add_aoa(newWorksheet, [["תעודת זהות","שם עובד", "מקדמה"]], { origin: "A1" });

        XLSX.writeFile(newWorkbook, "Payroll-Hilan-" + payPeriod + ".xlsx");
    } catch (e) {
        console.error("Error generating Hilan payroll file:", e);
    }
}

